import React, { useContext, useEffect, useState } from 'react';

import { CurrentUserContext } from '../../../Contexts/CurrentUserContext';
import './ResourceVideoConf.css';
import api from '../../../Utils/Api';

import Button from '../../App/Common/Button/Button';

const ResourceVideoConf = ({ data }) => {
    //console.log(data)
    const { token } = useContext(CurrentUserContext)
    // const [client, setClient] = useState(ZoomVideo.createClient())
   
    return (

        <>
            <div className='videoChatRoom__container'>

            </div>
        </>
    )
}
export default ResourceVideoConf
